import { observer } from 'mobx-react';
import { Component } from 'react';
import MenuProducts from '../MenuProducts/MenuProducts';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { LOCALES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { menuStore } from 'src/mobx/menuStore';
import Icon from 'src/view/components/Controls/Icon/Icon';

@observer
export default class MenuFavorites extends Component<{}, {}> {
  back = () => {
    menuStore.changeFavoritesVisibility(false);
  };

  render() {
    return (
      <div className="d-flex flex-column menu-category">
        <div onClick={this.back} className="d-flex flex-row align-items-center text-pointer">
          <Icon name={localeStore.language === LOCALES.AR ? Icons.SliderRight : Icons.SliderLeft} size={20} className="color-mainblue mr-4" />
          <span className="text-size-26 family-bold">{localeStore.t('favorite_items')}</span>
        </div>
        <MenuProducts />
      </div>
    );
  }
}
